import React from "react";
import Header from "../layouts/Header/";
import Footer from "../layouts/Footer";
import SectionHeading from "../components/SectionHeading";

const CryptoDataHub = () => {
  return (
    <>
      <Header />

      <section className="section-padding-100 service_single_content_area">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-10 offset-md-1">
              <div className="service_single_content text-center mb-100">
                <SectionHeading title="Crypto DataHub" />
                <div className="service_cta mt-50" style={{ color: "white" }}>
                  <a
                    href="https://crypto.databeast.ai"
                    className="btn dream-btn"
                  >
                    Visit Crypto DataHub
                  </a>
                </div>
                <div className="service_content_area text-left mt-50">
                  <p className="w-text">
                    CryptoDataHub provides comprehensive information about all
                    cryptocurrency projects, including real-time price data,
                    social media channels, and detailed charts. Our platform
                    offers investors and enthusiasts a one-stop solution to
                    track and analyze their favorite crypto projects.
                  </p>

                  <div
                    className="service_features mt-30"
                    style={{ color: "white" }}
                  >
                    <h4 className="w-text">Key Features:</h4>
                    <ul className="w-text">
                      <li>
                        <i className="fa fa-check"></i> Comprehensive crypto
                        project listings
                      </li>
                      <li>
                        <i className="fa fa-check"></i> Real-time price tracking
                      </li>
                      <li>
                        <i className="fa fa-check"></i> Historical price charts
                        with advanced analytics
                      </li>
                      <li>
                        <i className="fa fa-check"></i> Social media channel
                        integrations
                      </li>
                      <li>
                        <i className="fa fa-check"></i> Project fundamentals and
                        tokenomics
                      </li>
                      <li>
                        <i className="fa fa-check"></i> Market data and trading
                        volume
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default CryptoDataHub;
